import { render, staticRenderFns } from "./HeaderGroupComponent.vue?vue&type=template&id=60f94d67&scoped=true"
import script from "./HeaderGroupComponent.vue?vue&type=script&lang=js"
export * from "./HeaderGroupComponent.vue?vue&type=script&lang=js"
import style0 from "./HeaderGroupComponent.vue?vue&type=style&index=0&id=60f94d67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f94d67",
  null
  
)

export default component.exports